import { useEventDetail, useEventStatus } from '@/hooks/use-sbk-event-details-cache';
import { AtLeast } from '@/types/utils';

import { getEventTitle } from '../utils/utils';
import { BetEvent } from './types';

/** `getEventTitle` with the event's status/details overlaid from the live event-details cache. */
export const useEventTitle = (
    event: AtLeast<BetEvent, 'id' | 'status' | 'home_team' | 'away_team' | 'event_details' | 'start_time' | 'sport'>
) => {
    const eventDetails = useEventDetail(event.id) ?? event.event_details;
    const eventStatus = useEventStatus(event.id) ?? event.status;
    return getEventTitle({ ...event, status: eventStatus, event_details: eventDetails });
};
